import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchNotificationList,
  fetchUnreadNotificationCount,
} from "src/services/notification.service";

interface FetchNotificationListPayload {
  page: number;
  limit: number;
}

export const doFetchNotificationList = createAsyncThunk(
  "notification/fetchNotificationList",
  async (payload: FetchNotificationListPayload) => {
    try {
      const response: any = await fetchNotificationList({
        page: payload.page,
        limit: payload.limit,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch notification list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchUnreadNotificationCount = createAsyncThunk(
  "notification/fetchUnreadNotificationCount",
  async () => {
    try {
      const response: any = await fetchUnreadNotificationCount();
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to fetch unread notification count";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);
